import React from 'react';
import ShopifyFulfilmentsTable from './components/ShopifyFulfilmentsTable';

const ShopifyFulfilments = () => (
  <ShopifyFulfilmentsTable />
);

export default ShopifyFulfilments;
